import { useMutation } from "@apollo/client";
import { graphql } from "gql/apollo";
import { UpdateDarkWebStreamParams } from "gql/apollo/graphql";
import { useCallback } from "react";
import { ListStreams } from "../queries/useListStreams";

export const UpdateDarkWebStream = graphql(/* GraphQL */ `
	mutation UpdateDarkWebStream($params: UpdateDarkWebStreamParams!) {
		updateDarkWebStream(params: $params) {
			error {
				code
				message
			}
			success
		}
	}
`);

export function useUpdateDarkWebStream() {
	const [updateDarkWebStream] = useMutation(UpdateDarkWebStream, {
		refetchQueries: [ListStreams, "ListStreams"],
	});

	const handleUpdateDarkWebStream = useCallback(
		async (params: UpdateDarkWebStreamParams) => {
			const result = await updateDarkWebStream({
				variables: {
					params,
				},
			});

			return {
				success: result.data?.updateDarkWebStream.success,
				error: result.data?.updateDarkWebStream.error,
			};
		},
		[updateDarkWebStream]
	);

	return { handleUpdateDarkWebStream };
}
